<template>
  <div>
    <template v-if="isMoreInfoIndex">
      <div
        :class="[
          'mb-20',
          {
            'mb-sm-30 mb-lg-40': !deviceType.isMobile,
          },
        ]"
      >
        <page-title
          :title="$t('components.sub.navigation.title')"
          :bordered="true"
          :back-button="{ url: 'profile', hiddenAfterSizes: 'sm' }"
        />
      </div>

      <div>
        <div
          :class="[
            'px-20 mb-20',
            {
              'px-md-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
            },
          ]"
        >
          <div class="new-container mx-auto">
            <station :list="moreInfoMenu" />
          </div>
        </div>
      </div>
      <div class="tw-invisible tw-hidden tw-text-white">
        <p>{{ clientVersion }}</p>
      </div>
    </template>
    <template v-else>
      <div>
        <div
          :class="[
            'mb-20',
            {
              'mb-sm-30 mb-lg-40': !deviceType.isMobile,
            },
          ]"
        >
          <div
            :class="[
              'display-none',
              {
                'display-lg-block': !deviceType.isMobile,
              },
            ]"
          >
            <page-title titleTag="h2" :title="$t('components.sub.navigation.title')" :bordered="true" />
          </div>
          <div
            :class="[
              'display-block',
              {
                'display-lg-none': !deviceType.isMobile,
              },
            ]"
          >
            <page-title
              v-if="!deviceType.isDesktop"
              :title="$t(mobileTitleAndRoute.key)"
              :bordered="true"
              :back-button="{
                url: mobileTitleAndRoute.backRoute,
                hiddenAfterSizes: 'sm',
              }"
            />
          </div>
        </div>

        <div
          :class="[
            'px-0 mb-20',
            {
              'px-lg-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
            },
          ]"
        >
          <div class="new-container mx-auto">
            <template v-if="!isMoreInfoIndex">
              <div class="tw-px-5 md:tw-px-7.5 lg:tw-px-0">
                <Breadcrumb :breadcrumbs="breadcrumbList" />
              </div>
            </template>
            <div
              :class="[
                'tw-grid tw-grid-cols-6 tw-gap-7.5',
                {
                  'md:tw-grid-cols-12': !deviceType.isMobile,
                },
              ]"
            >
              <div
                :class="[
                  'tw-hidden',
                  {
                    'lg:tw-flex lg:tw-col-span-4': !deviceType.isMobile,
                  },
                ]"
              >
                <div class="tw-w-full">
                  <left-menu :title="$t('components.sub.navigation.title')" :list="moreInfoMenu" />
                </div>
              </div>
              <div
                :class="[
                  'tw-col-span-6',
                  {
                    'md:tw-col-span-12 lg:tw-col-span-8 lg:tw-col-start-5 xl:tw-col-span-7 xl:tw-col-start-6':
                      !deviceType.isMobile,
                  },
                ]"
              >
                <nuxt-child />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import PageTitle from '~/components/shared/page-title.vue'
  import Station from '~/components/shared/station.vue'
  import LeftMenu from '~/components/menus/left.vue'
  import Breadcrumb from '~/components/shared/breadcrumb'

  export default {
    components: {
      PageTitle,
      Station,
      LeftMenu,
      Breadcrumb,
    },

    data() {
      return {
        moreInfoTitles: [
          {
            routeName: 'blog',
            key: 'components.sub.navigation.blog',
            backRoute: 'more-info',
          },
          {
            routeName: 'referral',
            key: 'components.main.navigation.referral-page',
            backRoute: 'more-info',
          },
          {
            routeName: 'more-info-index-contact',
            key: 'components.sub.navigation.contact-us',
            backRoute: 'more-info',
          },
          {
            routeName: 'more-info-index-privacy-policy',
            key: 'components.sub.navigation.privacy',
            backRoute: 'more-info',
          },
          {
            routeName: 'more-info-index-terms-conditions',
            key: 'components.main.navigation.terms-conditions',
            backRoute: 'more-info',
          },
        ],

        moreInfoMenu: [
          {
            key: 'components.sub.navigation.help-center',
            route: '/help',
            isExternalRoute: true,
            group: 'first',
          },
          {
            key: 'components.sub.navigation.contact-us',
            route: {
              name: 'more-info-index-contact',
            },
            group: 'first',
          },
          {
            key: 'components.sub.navigation.blog',
            route: {
              name: 'blog',
            },
            group: 'first',
          },
          {
            key: 'components.sub.navigation.referral',
            route: {
              name: 'referral',
            },
            group: 'first',
          },
          {
            key: 'components.sub.navigation.privacy',
            route: {
              name: 'more-info-index-privacy-policy',
            },
            group: 'first',
          },
          {
            key: 'components.main.navigation.terms-conditions',
            route: {
              name: 'more-info-index-terms-conditions',
            },
            group: 'first',
          },
        ].map((item) => this.$utils.getShortLocalesCodeForHelp(item, null)),

        allBreadcrumbList: [
          {
            key: 'more-info-index',
            title: this.$t('components.breadcrumb.more-info'),
            link: 'more-info',
          },
          {
            key: 'index-privacy-policy',
            title: this.$t('components.breadcrumb.privacy-policy'),
            link: 'more-info-index-privacy-policy',
          },
          {
            key: 'index-contact',
            title: this.$t('components.breadcrumb.contact-us'),
            link: 'more-info-index-contact',
          },
          {
            key: 'index-terms-conditions',
            title: this.$t('components.breadcrumb.terms-conditions'),
            link: 'more-info-index-terms-conditions',
          },
        ],
      }
    },

    computed: {
      clientVersion() {
        return this.$config.clientVersion
      },

      deviceType() {
        return this.$store.getters.get_device_types
      },

      routeBaseName() {
        return this.getRouteBaseName() ? this.getRouteBaseName() : 'profile'
      },

      isMoreInfoIndex() {
        return this.routeBaseName === 'more-info' || this.routeBaseName === 'more-info-index'
      },

      breadcrumbList() {
        const routeBase = this.routeBaseName

        let list = this.allBreadcrumbList ? this.allBreadcrumbList.filter((v) => routeBase.includes(v.key)) : []

        return list
      },

      mobileTitleAndRoute() {
        const mobileTitleAndRoute = this.getMobileKey()
        return mobileTitleAndRoute
          ? this.getMobileKey()
          : {
              key: '',
              backRoute: 'more-info',
            }
      },
    },

    head() {
      return {
        title: this.$te('seo.more.info.title') ? this.$t('seo.more.info.title') : this.$t('seo.homepage.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.more.info.description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.more.info.keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.more.info.title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.more.info.description'),
          },
        ],
      }
    },

    methods: {
      getMobileKey() {
        return this.moreInfoTitles ? this.moreInfoTitles.find((v) => v.routeName === this.getRouteBaseName()) : null
      },
    },

    scrollToTop: true,
  }
</script>
